import React from "react";
import uuid from "react-uuid";
import { StyledCard } from "../../../styles/pages/GestaoFaltas/GestaoFaltas";
import {
    StyledCardHour,
    StyledCardTeacher,
    StyledCardTitle,
} from "../../../styles/pages/AcademicActivityPlanStyles";
import StringUtils from "../../../utils/types/StringUtils";
import WorkflowActions from "./WorkflowActions/WorkflowActions";
import { useWorkflow } from "../../../context/WorkflowContext";

const WorkflowItem = ({ workflow }: any) => {
    const { workflowFilter } = useWorkflow();
    const formatDate = "dd/MM/yyyy";

    const handleName = () => {
        return workflow.docente?.nome || workflow.nomeDocente;
    };

    const handleDate = () => {
        return workflow.data || workflow.created || workflow.dtInsert;
    };

    return (
        <StyledCard key={uuid()}>
            <div>
                <StyledCardTitle>
                    {workflowFilter.workflowTypeId.toString() !== "5"
                        ? workflowFilter.workflowTypeName
                        : "Aprovação de TACH"}
                </StyledCardTitle>
                <StyledCardTeacher>
                    {workflowFilter.workflowTypeId.toString() !== "5"
                        ? handleName()
                        : `${handleName()} - ${workflow.docente.matriculaAdp}`}
                </StyledCardTeacher>
                <div>
                    <StyledCardHour>
                        {workflowFilter.workflowTypeId.toString() !== "5"
                            ? `Enviado em: ${StringUtils.formatDateString(
                                  handleDate(),
                                  formatDate
                              )}`
                            : `Vigência: ${workflow.vigenciaDocumento}`}
                    </StyledCardHour>
                </div>
            </div>
            <WorkflowActions workflow={workflow} />
        </StyledCard>
    );
};

export default WorkflowItem;
